import * as React from 'react';
import { List, ListItemText, makeStyles } from '@material-ui/core';
import { Icon } from '@mitie/material-ui-extensions';
import {
	faBuilding,
	faEdit,
	faCity,
	faCalendarStar,
	faMapMarkerEdit,
	faPencilRuler,
} from '@fortawesome/pro-light-svg-icons';
import {
	faEdit as faEditSolid,
	faBuilding as faBuildingSolid,
	faCity as faCitySolid,
	faCalendarStar as faCalendarStarSolid,
	faMapMarkerEdit as faMapMarkerEditSolid,
	faPencilRuler as faPencilRulerSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { stores } from '../../store';
import { IHeaderNavProps } from '../../types';
import { observer } from 'mobx-react-lite';
import sidebarUseStyles from '../../assets/css/SideBarCss';
import clsx from 'clsx';
const useStyles = makeStyles(theme => ({
	listChildItemSelected: {
		backgroundColor: '#CFDBE5 !important',
	},
	PermissionsView: {
		display: 'none',
	},
}));

const HeaderNav = observer((props: IHeaderNavProps) => {
	const routes = React.useContext(stores.context.routes);
	const { routeName } = routes;
	const classesSideBar = sidebarUseStyles();
	const classesnew = useStyles();
	const [selectedItem, setSelectedItem] = React.useState('');
	const [selectedMenuItem, setSelectedMenuItem] = React.useState('');
	const [contentClicked, setContentClicked] = React.useState(false);
	const classes = props.classNames;
	const appStores = React.useContext(stores.context.appStores);
	const spacesList: string[] = ['spacesHome', 'siteInfo', 'myBookings', 'bookingsView'];
	const user = React.useContext(stores.context.user);
	const floordata = user.floorsingledata ? user.floorsingledata : '';
	const spaces = React.useContext(stores.context.spaces);
	const contentManagementList: string[] = [
		'spaces',
		'floorplanUploader',
		'floorplanEditor',
		'editSiteInfo',
		'floorplans',
	];
	const contentManagementListSelected = !!routeName && !!contentManagementList.includes(routeName);
	const spacesRoutesSelected = !!routeName && !!spacesList.includes(routeName);
	const [openCont, setOpenCont] = React.useState(false || contentManagementListSelected);
	const [open, setOpen] = React.useState(spacesRoutesSelected || contentManagementListSelected);
	const [editFloorPlansClicked, setEditFloorPlansClicked] = React.useState(false);
	React.useEffect(() => {
		if (['floorplanEditor', 'floorplanUploader'].includes(routeName!)) {
		} else {
			if (selectedItem === 'spaces' || routeName === selectedItem) navigateToMainPage('spacesHome');
			if (selectedItem === 'spaces') navigateToPage('spaces');
			else if (selectedItem === routeName || selectedMenuItem === routeName) {
				navigateToMainPage('spacesHome');
				setOpenCont(false);
			}
		}
		spaces.fetchCondecoDetails(user.currentSiteId);
	}, [user.currentSiteId, routeName, selectedItem, selectedMenuItem]);
	React.useEffect(() => {
		if ((!openCont && contentClicked) || editFloorPlansClicked) navigateToMainPage('spacesHome');
	}, [contentClicked]);

	const handleClick = () => {
		setOpen(true);
	};
	const navigateToPage = (route: string) => {
		routes.navigate(
			{ name: route },
			{
				clearParams: true,
			},
		);
	};

	const navigateToMainPage = (route: string) => {
		routes.navigate(
			{
				name: route,
				params: {
					clientId: floordata.length > 0 ? floordata.clientId : 'NA',
					floorId: floordata.length > 0 ? floordata.floorId : 'NA',
				},
			},
			{
				clearParams: true,
			},
		);
	};

	const [editSiteInfo, setEditSiteInfo] = React.useState(0);

	React.useEffect(() => {
		if (
			user.permissions &&
			user.permissions.Modules.find((m: any) => m.ModuleId === '6846202B-42E2-4FD0-B81D-EE71FC6D2DE8')
		) {
			const spacesIndex = user.permissions.Modules.findIndex(
				(m: any) => m.ModuleId === '6846202B-42E2-4FD0-B81D-EE71FC6D2DE8',
			);
			if (user.permissions.Modules[spacesIndex] && user.permissions.Modules[spacesIndex].Read) {
				if (
					user.permissions.Modules[spacesIndex].Create &&
					user.permissions.Modules[spacesIndex].Update &&
					user.permissions.Modules[spacesIndex].Delete
				) {
					setEditSiteInfo(1);
				}
			} else {
				setEditSiteInfo(0);
			}
		}
	}, [user.permissions]);

	return (
		<>
			<List
				disablePadding={false}
				className={
					user.modulePermissions && user.modulePermissions.SPACES
						? props.drawerOpen
							? classes.sideBarList
							: classes.miniSideBarList
						: classesnew.PermissionsView
				}
			>
				<li
					title={!props.drawerOpen ? 'Spaces' : ''}
					onClick={() => {
						handleClick();
						navigateToMainPage('spacesHome');
						appStores.drawerOpen = false;
					}}
					aria-expanded={open}
					aria-controls="spaces-home-collapse"
				>
					<a
						aria-label={routeName === 'spacesHome' ? 'Spaces Current' : 'Spaces'}
						href="javascript:void(0)"
						className={clsx(
							'ancharTag',
							{
								subMenuMiniSideBar: !props.drawerOpen,
							},
							routeName === 'spacesHome' ||
								routeName === 'bookingsView' ||
								spacesRoutesSelected ||
								contentManagementListSelected
								? 'selected'
								: 'main-menu',
						)}
					>
						<span className={classes.listIcon}>
							<Icon
								icon={
									routeName === 'spacesHome' ||
									routeName === 'bookingsView' ||
									spacesRoutesSelected ||
									contentManagementListSelected
										? faBuildingSolid
										: faBuilding
								}
							/>
						</span>
						{props.drawerOpen && <ListItemText primary="Spaces" />}
					</a>
				</li>
			</List>

			{open && (
				<List
					id="spaces-home-collapse"
					aria-live="polite"
					component={'ul'}
					disablePadding={false}
					className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
				>
					{spaces.condecoDetails && spaces.condecoDetails.ISEMSAvailable ? (
						<li
							title={!props.drawerOpen ? 'My Bookings' : ''}
							onClick={() => {
								navigateToPage('myBookings');
								setSelectedMenuItem('myBookings');
								appStores.drawerOpen = false;
							}}
						>
							<a
								aria-label={routeName === 'myBookings' ? 'My Bookings Current' : 'My Bookings'}
								href="javascript:void(0)"
								className={clsx(
									'ancharTag',
									{
										subMenuMiniSideBar: !props.drawerOpen,
									},
									routeName === 'myBookings' || routeName === 'bookingsView'
										? 'selected sub-menu-selected'
										: 'sub-menu',
								)}
							>
								<span className={classes.listIcon}>
									<Icon
										icon={
											routeName === 'myBookings' || routeName === 'bookingsView' ? faCalendarStarSolid : faCalendarStar
										}
									/>
								</span>
								{props.drawerOpen && <ListItemText primary="My Bookings" />}
							</a>
						</li>
					) : (
						''
					)}
					<li
						title={!props.drawerOpen ? 'Site Information' : ''}
						onClick={() => {
							navigateToPage('siteInfo');
							setSelectedMenuItem('siteInfo');
							appStores.drawerOpen = false;
						}}
					>
						<a
							aria-label={routeName === 'siteInfo' ? 'Site Information Current' : 'Site Information'}
							href="javascript:void(0)"
							className={clsx(
								'ancharTag',
								{
									subMenuMiniSideBar: !props.drawerOpen,
								},
								routeName === 'siteInfo' ? 'selected sub-menu-selected' : 'sub-menu',
							)}
						>
							<span className={classes.listIcon}>
								<Icon icon={routeName === 'siteInfo' ? faCitySolid : faCity} />
							</span>
							{props.drawerOpen && <ListItemText primary="Site Information" />}
						</a>
					</li>
					{editSiteInfo === 1 && appStores.showAppLoader === false ? (
						<>
							<li
								title={!props.drawerOpen ? 'Content Management' : ''}
								onClick={() => {
									setOpenCont(!openCont);
									setOpen(true);
									setContentClicked(true);
								}}
								aria-label={openCont ? 'Collapse content management' : 'Expand content management'}
								aria-expanded={openCont}
								aria-controls="content-management-collapse"
							>
								<button
									className={clsx(
										'ancharTag buttonFocus',
										{
											subMenuMiniSideBar: !props.drawerOpen,
										},
										contentManagementListSelected || openCont ? 'selected sub-menu-selected' : 'sub-menu',
									)}
								>
									<span className={classes.listIcon}>
										<Icon icon={contentManagementListSelected || openCont ? faEditSolid : faEdit} />
									</span>
									{props.drawerOpen && <ListItemText primary="Content Management" style={{ textAlign: 'left' }} />}
								</button>
							</li>
							<li>
								{openCont && (
									<List
										id="content-management-collapse"
										aria-live="polite"
										component="ul"
										disablePadding={false}
										className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
									>
										<li
											title={!props.drawerOpen ? 'Edit Floor Plans' : ''}
											onClick={() => {
												navigateToPage('spaces');
												setSelectedItem('spaces');
												setEditFloorPlansClicked(true);
												appStores.drawerOpen = false;
											}}
										>
											<a
												aria-label={routeName === 'floorplanEditor' ? 'Edit Floor Plans Current' : 'Edit Floor Plans'}
												href="javascript:void(0)"
												className={clsx(
													'ancharTag',
													{
														subMenuMiniSideBar: !props.drawerOpen,
													},
													routeName === 'spaces' || routeName === 'floorplanEditor'
														? 'selected sub-menu-selected'
														: 'sub-menu',
												)}
											>
												<span className={classes.listIcon}>
													<Icon
														icon={
															routeName === 'spaces' || routeName === 'floorplanEditor'
																? faPencilRulerSolid
																: faPencilRuler
														}
													/>
												</span>
												{props.drawerOpen && <ListItemText style={{ paddingLeft: '0px' }} primary="Edit Floor Plans" />}
											</a>
										</li>
										<li
											title={!props.drawerOpen ? 'Edit Site Information' : ''}
											onClick={() => {
												navigateToPage('editSiteInfo');
												setSelectedItem('editSiteInfo');
												appStores.drawerOpen = false;
											}}
										>
											<a
												aria-label={
													routeName === 'editSiteInfo' ? 'Edit Site Information Current' : 'Edit Site Information'
												}
												href="javascript:void(0)"
												className={clsx(
													'ancharTag',
													{
														subMenuMiniSideBar: !props.drawerOpen,
													},
													routeName === 'editSiteInfo' ? 'selected sub-menu-selected' : 'sub-menu',
												)}
											>
												<span className={classes.listIcon}>
													<Icon icon={routeName === 'editSiteInfo' ? faMapMarkerEditSolid : faMapMarkerEdit} />
												</span>
												{props.drawerOpen && (
													<ListItemText primary="Edit Site Information" style={{ paddingLeft: '0px' }} />
												)}
											</a>
										</li>
									</List>
								)}
							</li>
						</>
					) : (
						''
					)}
				</List>
			)}
		</>
	);
});

export default HeaderNav;
